//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.09.2016.
 */


(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnDateFilter', srsngTableColumnDateFilter);

    function srsngTableColumnDateFilter() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mega-table/filter/date/date.html',
            scope: {
                data: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope) {

            $scope.parse = date => {


                let moDate = moment.utc(`${date.date} ${date.hour}:${date.minute}`, 'YYYY-MM-DD HH:mm', true);
                if (moDate.isValid()) {
                    setDate(date, moDate.format());
                } else {
                    if (date.name === 'to') {
                        moDate = moment.utc(`${date.date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss', true);
                    } else {
                        moDate = moment.utc(`${date.date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss', true);
                    }

                    if (moDate.isValid()) {
                        setDate(date, moDate.format());
                    } else {
                        moDate = moment.utc(`${date.date}`, 'YYYY-MM-DD', true);
                        if (moDate.isValid()) {
                            setDate(date, moDate.format());
                        }
                    }
                }

                $scope.filter();
            };

            $scope.step = (date, period, step) => {
                setDate(date, moment.utc(date.isoDate).add(step, period).format());
                $scope.filter();
            };

            // $scope.toggleAmPm = date => {
            //     date.amPm = date.amPm == 'AM' ? 'PM' : 'AM';
            //     $scope.parse(date);
            //     $scope.filter();
            // };

            $scope.sort = direction => {

                $scope.filter();
            };

            $scope.search = () => {

                $scope.filter();
            };

            $scope.filter = () => {
                $scope.data.callback($scope.data);
            };

            $scope.reset = () => {

                $scope.data.fromDate = _.cloneDeep($scope.data.originalFromDate);
                $scope.data.toDate = _.cloneDeep($scope.data.originalToDate);
                $scope.filter();
            };

            init();

            function init() {

                if ($scope.data.searchText == null)
                    $scope.data.searchText = '';

                if ($scope.data.fromDate == null) {

                    $scope.data.fromDate = {
                        name: 'from',
                        label: 'From'
                    };

                    setDate($scope.data.fromDate, null);
                    $scope.data.originalFromDate = _.cloneDeep($scope.data.fromDate);
                }

                if ($scope.data.toDate == null) {

                    $scope.data.toDate = {
                        name: 'to',
                        label: 'To'
                    };

                    setDate($scope.data.toDate, null);
                    $scope.data.originalToDate = _.cloneDeep($scope.data.toDate);
                }
            }

            function setDate(date, isoDate) {

                if (!isoDate) {
                    date.isoDate = date.date = date.hour = date.minute = null;
                    // date.amPm = 'AM';
                    return;
                }

                let moDate = moment.utc(isoDate);
                date.isoDate = isoDate;
                date.date = moDate.format('YYYY-MM-DD');
                date.hour = moDate.format('HH');
                date.minute = moDate.format('mm');
                // date.amPm = moDate.format('A');
            }
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
